import { useState } from "react";
import { PageList } from "../../components/pageList";
import {
  ENUM_FORM_LAYOUT_CONTAINER,
  ENUM_FORM_DISPLAY,
} from "../../components/pageList";
import { useCellRender } from "../../hooks/useCellRender";
import { TextInput, Switch, Textarea, Select } from "@mantine/core";
import ActionCellRender from "../../components/actionCellRender";
import { IconTrash, IconPencil, IconCopy } from "@tabler/icons";
import AutoCodeInput from "../../components/autoCodeInput";
import moment from "moment";

const apiEntity = "team";

const tableSchema = {
  showActionColumn: true,
  searchableFields: ["name", "code"],
  title: "Teams",
  apiEntity,
  columns: [
    {
      field: "code",
      headerName: "Team Code",
    },
    {
      field: "name",
      headerName: "Name",
    },
    {
      field: "cname",
      headerName: "Chinese Name",
    },

    {
      field: "createdAt",
      headerName: "Created At",
      cellRender: (col, data) =>
        moment(data.createdAt).format("YYYY-MM-DD HH:mm"),
    },
    {
      field: "action",
      cellRender: ActionCellRender,
      isAction: true,
      actions: [
        {
          name: "edit",
          icon: IconPencil,
          props: {
            //   color:"red"
          },
        },
      ],
      actionMenu: [
        {
          name: "copy",
          label: "Copy",
          icon: IconCopy,
          props: {},
        },
        {
          name: "delete",
          label: "Delete data",
          icon: IconTrash,
          props: {
            color: "red",
          },
        },
      ],
    },
  ],
};

const formSchema = {
  title: "Team",
  apiEntity,
  display: {
    mode: ENUM_FORM_DISPLAY.DRAWER,
    position: "right",
    size: "xl",
  },
  initialValues: {
    code: "",
    name: "",
    cname: "",
  },
  layout: {
    fields: [
      {
        name: "code",
        component: AutoCodeInput,

        props: {
          required: true,
          uniqueEntity: "team",
          errorMessage: "Team Code is already exist.",
          label: "Team Code",
          placeholder: "",
        },
      },
      {
        name: "name",
        component: TextInput,
        props: {
          required: true,
          label: "Name",
          placeholder: "",
        },
      },
      {
        name: "cname",
        component: TextInput,
        label: "Chinese Name",
        props: {
          //   required: true,
          label: "Chinese Name",
          placeholder: "",
        },
      },
      {
        name: "description",
        component: Textarea,
        props: {
          //   required: true,
          label: "Description",
          placeholder: "",
        },
      },
    ],
  },
};

const Team = () => {
  return (
    <PageList
      title={"Teams"}
      apiEntity={apiEntity}
      tableSchema={tableSchema}
      formSchema={formSchema}
      showImport={false}
    />
  );
};

export default Team;
